// extracted by mini-css-extract-plugin
export default {"WrapShareButton":"uNNTAhBj4n67qQEHTdHAIg==","halfWidth":"_4jcsznHMkkD2fsqwJMaG8A==","fullWidth":"BfAxbYIJaCz871FKZ30DtQ=="};